/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  getParameter: state => paramSearch => {
    if (!state.parameters) return {};
    const result = state.parameters.filter((parameter) => parameter.id === paramSearch);
    return result.length ? result.pop() : {};
  },

  categoriesList: state => {
    const list = [];
    if (state.categories) {
      if (state.categories.list) {
        state.categories.list.forEach(function (item) {
          if (item.parentId == '') {
            list.push({...item, parentName: '', displayName: item.name.trim()});
          } else {
            const category = state.categories.list.filter((category) => category.id == item.parentId);
            if (category.length > 0) {
              const parentName = category.pop().name;
              list.push({...item, parentName: parentName, displayName: `${parentName} / ${item.name.trim()}`});
            } else {
              list.push({...item, parentName: '', displayName: item.name.trim()});
            }
          }
        });
      }
    }
    return list;
  },
  getCategory: (state, getters) => paramSearch => {
    if (state.categories) {
      const result = getters.categoriesList.filter((category) => category.id === paramSearch);
      return result.length ? result.pop() : [];
    } else {
      return null;
    }
  },

  versionsList: state => {
    let list = [];
    if (state.versions) {
      if (state.versions.list) {
        list = [...state.versions.list];
      }
    }
    return list;
  },
  getVersion: state => paramSearch => {
    const result = state.versions.list.filter(version => version.id === paramSearch);
    return result.length ? result.pop() : [];
  },

  fontSizesList: state => {
    let list = [];
    if (state.fontSizes) {
      if (state.fontSizes.list) {
        list = [...state.fontSizes.list];
      }
    }
    return list;
  },
  getFontSize: state => paramSearch => {
    const result = state.fontSizes.list.filter(fontSize => fontSize.id === paramSearch);
    return result.length ? result.pop() : [];
  },

  productsList: state => {
    const list = [];
    if (state.products) {
      if (state.products.list) {
        state.products.list.forEach(function (item) {
          let categoryName = '';
          const statusName = item.status == 'ACT' ? 'Activo' : 'Inactivo';
          // Se calcula el nombre de categoría solo si el producto tiene una
          // categoría asignada, pero el producto siempre se incluye en la
          // lista (antes se excluía por completo cuando 'categories' venía
          // vacío, lo cual rompía la página de detalle de esos productos).
          if (item.categories) {
            const categoryId = parseInt(item.categories.split(',').pop());
            const category = state.categories.list.filter((category) => category.id == categoryId);
            if (category.length > 0) {
              categoryName = category.pop().name;
            }
          }
          const videoURL = item.hasOwnProperty('videoURL') ? item.videoURL : '';
          const originalPrice = (item.hasOwnProperty('originalPrice') && typeof item.originalPrice === 'number') ? item.originalPrice : item.price;
          if (item.hasOwnProperty(('onSale')) && item.hasOwnProperty('salePrice')) {
            list.push({...item, categoryName: categoryName, statusName: statusName, searchField: `${item.isbn} | ${item.name}`, originalPrice: originalPrice, videoURL: videoURL});
          } else {
            list.push({...item, categoryName: categoryName, statusName: statusName, searchField: `${item.isbn} | ${item.name}`, onSale: false, salePrice: item.price, originalPrice: originalPrice, videoURL: videoURL});
          }
        });
      }
    }
    return list;
  },
  getProduct: (state, getters) => paramSearch => {
    let result = [];
    if (state.products) {
      if (state.products.list) {
        result = getters.productsList.filter((product) => product.id === paramSearch);
      }
    }
    return result.length ? result.pop() : [];
  },

  slidersList: state => {
    const list = [];
    if (state.sliders) {
      if (state.sliders.list) {
        state.sliders.list.forEach(function (item) {
          const statusName = item.status == 'ACT' ? 'Activo' : 'Inactivo';
          list.push({...item, statusName: statusName});
        });
      }
    }
    return list;
  },
  getSlider: state => paramSearch => {
    let result = [];
    if (state.sliders) {
      if (state.sliders.list) {
        result = state.sliders.list.filter((slider) => slider.id === paramSearch);
      }
    }
    return result.length ? result.pop() : [];
  },

  showcaseList: state => {
    const list = [];
    if (state.showcase) {
      if (state.showcase.list) {
        state.showcase.list.forEach(function (item) {
          const statusName = item.status == 'ACT' ? 'Activo' : 'Inactivo';
          list.push({...item, statusName: statusName});
        });
      }
    }
    return list;
  },
  getShowcase: state => paramSearch => {
    let result = [];
    if (state.showcase) {
      if (state.showcase.list) {
        result = state.showcase.list.filter((showcase) => showcase.id === paramSearch);
      }
    }
    return result.length ? result.pop() : [];
  },

  couponsList: (state, getters) => {
    const list = [];
    if (state.coupons) {
      if (state.coupons.list) {
        let applicationName = '';
        state.coupons.list.forEach(function (item) {
          applicationName = 'Todos los productos';
          if (item.applicationId == 'C') {
            applicationName = getters.getCategory(item.categoryId);
            if (applicationName) applicationName = applicationName.displayName;
          } else if (item.applicationId == 'P') {
            applicationName = getters.getProduct(item.productId);
            if (applicationName) applicationName = applicationName.name;
          }
          list.push({
            ...item,
            statusName: item.statusId == 'ACT' ? 'Activo' : 'Inactivo',
            applicationName: applicationName,
            typeName: item.typeId == 'P' ? 'Porcentaje' : 'Valor'
          });
        });
      }
    }
    return list;
  },
  getCoupon: state => paramSearch => {
    if (state.coupons) {
      const result = state.coupons.list.filter((coupon) => coupon.id === paramSearch);
      return result.length ? result.pop() : [];
    } else {
      return null;
    }
  }

};

export default getters
